import React from 'react';
import { useCareGapGlobalContext } from '../../context';
import { GlobalContext } from '../../../../../../../components/GlobalContext';
import { usePanelPatientsMeCcQuery } from '../../../../../../Panels/ViewPanels/PanelPatients/index.generated';
import { useFetchTableData } from '../../../../../../../hooks/useFetchTableData';
import { CareGapPatientNotFound } from '../CareGapPatientTableNotFound';
import { CareGapPatientTableView } from './View';

type Props = {
  limit?: number;
  skip?: number;
  setLimit: (limit: number) => any;
  setSkip: (limit: number) => any;
  availableActions?: string[];
  setLoading: (input: boolean) => void;
  setDisplayedCount: (input: number) => void;
  sortBy: { field: string; method: 'desc' | 'asc' };
  setSortBy: (input: any) => void;
  setResults: (input: any) => void;
  showMyOwn: string;
};

export const CCCareGapPatientSearchingTableContainer = (props: Props) => {
  const {
    limit,
    skip,
    setLimit,
    setSkip,
    setLoading,
    setDisplayedCount,
    sortBy,
    setSortBy,
    setResults,
  } = props;
  const [selected, setSelected] = React.useState<any[]>([]);
  const { searchName, searchDob } = useCareGapGlobalContext();

  React.useEffect(() => {
    setSkip(0);
  }, [searchName, limit, searchDob]);

  const patients = usePanelPatientsMeCcQuery({
    variables: {
      input: {
        andName: searchName,
        andDob: searchDob,
        skip: skip,
        limit: limit,
        sortBy: [{ ...sortBy }],
        showMyOwn: props.showMyOwn,
      },
    },
  });

  React.useEffect(() => {
    if (!patients.called || patients.loading) {
      setLoading(true);
    } else {
      setLoading(false);
      setDisplayedCount(patients.data?.getAllPatients.count ?? 0);
      setResults(patients.data?.getAllPatients.results || []);
    }
  }, [patients]);
  const queryResult = useFetchTableData(patients);
  if (!patients.called || patients.loading) {
    return <></>;
  }

  return (
    <div style={{ width: '100%' }}>
      {patients?.data?.getAllPatients!.count == 0 ? (
        <CareGapPatientNotFound isSearching={true} />
      ) : (
        <CareGapPatientTableView
          refetchDataFunc={{
            func: patients.refetch,
            params: {
              andName: searchName,
              andDob: searchDob,
              skip: skip,
              limit: limit,
              sortBy: [{ ...sortBy }],
              showMyOwn: props.showMyOwn,
            },
          }}
          sortBy={sortBy}
          setSortBy={setSortBy}
          patients={queryResult ? queryResult.getAllPatients.results : []}
          limit={limit ?? 10}
          skip={skip ?? 0}
          setLimit={setLimit}
          setSkip={setSkip}
          count={queryResult ? queryResult.getAllPatients!.count : 0}
          setSelected={setSelected}
          selected={selected}
        />
      )}
    </div>
  );
};
